var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g(_vm._b({class:[
    'vast-service-order-now-btn',
    {
      'vast-service-order-now-btn--text': _vm.text,
    }
  ],style:(_vm.styleButton),attrs:{"disabled":_vm.disabled || !!_vm.loading}},'button',_vm.$props,false),_vm.$listeners),[(!_vm.loading)?_c('div',{staticClass:"vast-service-order-now-btn__container"},[_vm._t("default")],2):[_c('div',{staticClass:"btn__loader"},[_c('OLoader')],1),_vm._v(" "+_vm._s(typeof _vm.loading === 'string' ? _vm.loading : _vm.locale.loadingText)+" ")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }